import {
	createRouter,
	createWebHistory,
	createWebHashHistory
} from 'vue-router'
import store from '../store/index'
import globle from '../util/globle'
import api from '../api/api.js'

const routes = [{
		path: '/',
		name: 'layout',
		redirect: '/home',
		component: () => import('@/views/layout.vue'),
		children: [{
				path: '/home',
				name: 'home',
				component: () => import('@/views/home/home.vue'),
				meta: {
					anonymous: true,
					KeepAlive: true,
				}
			},
			{
				path: '/zhiyuan',
				name: 'zhiyuan',
				component: () => import('@/views/fangAn/expert.vue'),
				meta: {
					anonymous: true,
					needLogin: true
				}
			},
			{
				path: '/server',
				name: 'server',
				component: () => import('@/views/person/server.vue'),
				meta: {
					anonymous: true,
					needLogin: true
				}
			},
			{
				path: '/orgView',
				name: 'orgView',
				component: () => import('@/views/template/orgView.vue'),
				meta: {
					anonymous: true
				}
			},
			{
				path: '/base',
				name: 'base',
				component: () => import('@/views/person/base.vue'),
				meta: {
					anonymous: true,
					needLogin: true
				}
			},
			{
				path: '/xieyi',
				name: 'xieyi',
				component: () => import('@/views/person/xieyi.vue'),
				meta: {
					anonymous: true,
					needLogin: true
				}
			},
			{
				path: '/virtualLogin',
				name: 'virtualLogin',
				component: () => import('@/views/account/virtualLogin.vue'),
				meta: {
					anonymous: true,
					needLogin: false,
					needBaseInfo: false
				}
			},
			{
				path: '/noserve',
				name: 'noserve',
				component: () => import('@/views/product/noserve.vue'),
				meta: {
					anonymous: true,
					needLogin: false
				}
			},
			// {
			// 	path: '/test',
			// 	name: 'test',
			// 	component: () => import('@/views/test/index.vue'),
			// 	meta: {
			// 		anonymous: true,
			// 		needLogin: false
			// 	}
			// },
		]
	},
	{
		path: '/',
		name: 'layout2',
		redirect: '/new',
		component: () => import('@/views/layout2.vue'),
		children: [{
				path: '/contentlist',
				name: 'contentlist',
				component: () => import('@/views/new/contentlist.vue'),
				meta: {
					anonymous: true,
					KeepAlive: true,
				}
			},
			{
				path: '/detail',
				name: 'detail',
				component: () => import('@/views/new/detail.vue'),
				meta: {
					anonymous: true,
					KeepAlive: true,
				}
			},
			{
				path: '/new',
				name: 'new',
				component: () => import('@/views/new/cp_newsListPlayer.vue'),
				meta: {
					anonymous: true,
					KeepAlive: true,
				}
			},
			{
				path: '/artsport',
				name: 'artsport',
				component: () => import('@/views/artSport/index.vue'),
				meta: {
					anonymous: true,
					needLogin: true
				}
			},
			{
				path: '/mygift',
				name: 'mygift',
				component: () => import('@/views/gift/mygifthistory.vue'),
				meta: {
					anonymous: true,
					needLogin: true
				}
			},
			{
				path: '/website',
				name: 'website',
				component: () => import('@/views/new/webSite.vue'),
				meta: {
					anonymous: true,
					KeepAlive: true,
				}
			},
			{
				path: '/score',
				name: 'score',
				component: () => import('@/views/fangAn/custom.vue'),
				//component: () => import('@/views/score/score.vue'),
				meta: {
					anonymous: true,
					needLogin: true,
					title: '志愿',
					needAuthority: true
				}
			},
			{
				path: '/fangan',
				name: 'fangan',
				component: () => import('@/views/fangAn/expert.vue'),
				// component: () => import('@/views/score/score.vue'),
				meta: {
					anonymous: true,
					needLogin: true,
					title: '志愿',
					needAuthority: true
				}
			},
			{
				path: '/score1',
				name: 'score1',
				component: () => import('@/views/score/PlanSearcher.vue'),
				meta: {
					anonymous: true,
					needLogin: true,
					needAuthority: true
				}
			},
			{
				path: '/score2',
				name: 'score2',
				component: () => import('@/views/score/score2.vue'),
				meta: {
					anonymous: true,
					needLogin: true
				}
			},
			{
				path: '/score3',
				name: 'score3',
				component: () => import('@/views/score/score3.vue'),
				meta: {
					anonymous: true,
					needLogin: false
				}
			},
			{
				path: '/score4',
				name: 'score4',
				component: () => import('@/views/score/score4.vue'),
				meta: {
					anonymous: true,
					needLogin: false
				}
			},
			{
				path: '/score5',
				name: 'score5',
				component: () => import('@/views/score/score5.vue'),
				meta: {
					anonymous: true,
					needLogin: false
				}
			},
			{
				path: '/msg',
				name: 'msg',
				component: () => import('@/views/message/msg.vue'),
				meta: {
					anonymous: true,
					needLogin: true
				}
			},
			{
				path: '/schoolFirst',
				name: 'schoolFirst',
				component: () => import('@/views/school/school_first.vue'),
				meta: {
					anonymous: true,
					KeepAlive: true,
				}
			},
			{
				path: '/schoolSecond',
				name: 'schoolSecond',
				component: () => import('@/views/school/school_second.vue'),
				meta: {
					anonymous: true,
					title: '院校详情'
				}
			},
			{
				path: '/majorFirst',
				name: 'majorFirst',
				component: () => import('@/views/major/major_first.vue'),
				meta: {
					anonymous: true,
					KeepAlive: true,
				}
			},
			{
				path: '/majorSecond',
				name: 'majorSecond',
				component: () => import('@/views/major/major_second.vue'),
				meta: {
					anonymous: true
				}
			},
			{
				path: '/record',
				name: 'record',
				component: () => import('@/views/record/record.vue'),
				meta: {
					anonymous: true,
					needLogin: true,
					needAuthority: true
				}
			},
			{
				path: '/phone',
				name: 'phone',
				component: () => import('@/views/person/phone.vue'),
				meta: {
					anonymous: true,
					needLogin: true
				}
			},
			{
				path: '/orgServer',
				name: '/orgServer',
				component: () => import('@/views/person/orgServer.vue'),
				meta: {
					needLogin: false,
				}
			},
			{
				path: '/pass',
				name: 'pass',
				component: () => import('@/views/person/pass.vue'),
				meta: {
					anonymous: true,
					needLogin: true
				}
			},
			{
				path: '/plan',
				name: 'plan',
				component: () => import('@/views/plan/plan.vue'),
				meta: {
					anonymous: true,
					needLogin: true
				}
			},

			{
				path: '/xuanke',
				name: 'xuanke',
				component: () => import('@/views/xuanke/index.vue'),
				meta: {
					anonymous: true,
					needLogin: true,
					title: '选科报告',
					needAuthority: true
				}
			},
			{
				path: '/ceping',
				name: 'ceping',
				component: () => import('@/views/paper/index.vue'),
				meta: {
					anonymous: true,
					needLogin: true,
					title: '测评',
				}
			},
			{
				path: '/cpdetail',
				name: 'cpdetail',
				component: () => import('@/views/paper/detail.vue'),
				meta: {
					anonymous: true,
					needLogin: true
				}
			},
			{
				path: '/schoolsubject',
				name: 'schoolsubject',
				component: () => import('@/views/subject/subject1.vue'),
				meta: {
					anonymous: true,
					needLogin: true
				}
			},
			{
				path: '/majorsubject',
				name: 'majorsubject',
				component: () => import('@/views/subject/subject3.vue'),
				meta: {
					anonymous: true,
					needLogin: true
				}
			},
			{
				path: '/totalsubject',
				name: 'totalsubject',
				component: () => import('@/views/subject/subject2.vue'),
				meta: {
					anonymous: true,
					needLogin: true
				}
			},
			{
				path: '/zhinan',
				name: 'zhinan',
				component: () => import('@/views/person/zhiNan.vue'),
				meta: {
					anonymous: true,
					needLogin: false
				}
			},
			{
				path: '/hotarea',
				name: 'hotarea',
				component: () => import('@/views/hotArea/index.vue'),
				meta: {
					anonymous: true,
					needLogin: true
				}
			},
			{
				path: '/expertor',
				name: 'expertor',
				component: () => import('@/views/expertor/list.vue'),
				meta: {
					anonymous: false,
					needLogin: false
				}
			},
			{
				path: '/buy',
				name: 'buy',
				component: () => import('@/views/buy/index.vue'),
				meta: {
					anonymous: true
				}
			},
			{
				path: '/authorityInfo',
				name: 'authorityInfo',
				component: () => import('@/views/authority/authorityInfo.vue'),
				meta: {
					anonymous: false
				}
			},
			{
				path: '/lessons',
				name: 'lessons',
				component: () => import('@/views/tifen/lesson.vue'),
				meta: {
					anonymous: false,
					needLogin: true
				}
			},
			{
				path: '/showpdf',
				name: 'showpdf',
				component: () => import('@/views/tifen/showpdf.vue'),
				meta: {
					anonymous: false,
					needLogin: true
				}
			},
			{
				path: '/videodetail',
				name: 'videodetail',
				component: () => import('@/views/tifen/videodetail.vue'),
				meta: {
					anonymous: false,
					needLogin: true
				}
			},

			{
				path: '/tifen',
				name: 'tifen',
				component: () => import('@/views/tifen/index.vue'),
				meta: {
					anonymous: false,
					needLogin: true,
					needAuthority: true
				}
			},
			{
				path: '/schoolMap',
				name: 'schoolMap',
				component: () => import('@/views/school/school_map.vue'),
				meta: {
					anonymous: true,
					KeepAlive: true,
				}
			},
			{
				path: '/product',
				name: 'product',
				component: () => import('@/views/product/buy.vue'),
				meta: {
					needLogin: true,
				}
			},
			{
				path: '/orderlist',
				name: 'orderlist',
				component: () => import('@/views/person/orderlist.vue'),
				meta: {
					needLogin: true
				}
			},
			{
				path: '/Occupation',
				name: 'Occupation',
				component: () => import('@/views/Occupation/index.vue'),
				meta: {
					anonymous: true
				}
			},
			{
				path: '/productlist',
				name: 'productlist',
				component: () => import('@/views/product/productlist.vue'),
				meta: {
					title: ''
				},
			},
			{
				path: '/receiveinfofirstbuy',
				name: 'receiveinfofirstbuy',
				component: () => import('@/views/product/receiveinfofirstbuy.vue'),
				meta: {
					title: ''
				},
			},
			{
				path: '/jiangZuo',
				name: 'jiangZuo',
				component: () => import('@/views/person/jiangZuo.vue'),
				meta: {
					title: ''
				},
			},
			{
				path: '/zhaosheng',
				name: 'zhaosheng',
				component: () => import('@/views/zhaosheng/index.vue'),
				meta: {
					needLogin: false,
				}
			},
			{
				path: '/zhaosheng/details',
				name: '/zhaosheng/details',
				component: () => import('@/views/zhaosheng/details.vue'),
				meta: {
					needLogin: false,
				}
			},
			{
				path: '/orgpub',
				name: '/orgpub',
				component: () => import('@/views/org/orgpub.vue'),
				meta: {
					needLogin: false,
				}
			},
			{
				path: '/stuzhiyuan/index',
				name: 'stuzhiyuan/index',
				component: () => import('@/views/stuZhiYuan/index.vue'),
				meta: {
					anonymous: false,
					needLogin: true,
					// title: '志愿',
					needAuthority: true
				}
			}, // register
			{
				path: '/stuzhiyuan/plan',
				name: 'stuzhiyuan/plan',
				component: () => import('@/views/stuZhiYuan/plan.vue'),
				meta: {
					anonymous: false,
					needLogin: true,
					needAuthority: true
				}
			},
			{
				path: '/stuzhiyuan/zhiyuan',
				name: 'stuzhiyuan/zhiyuan',
				component: () => import('@/views/stuZhiYuan/zhiyuan.vue'),
				meta: {
					anonymous: false,
					needLogin: true,
					needAuthority: true
				}
			},
			{
				path: '/stuzhiyuan/autoZhiYuan',
				name: 'stuzhiyuan/autoZhiYuan',
				component: () => import('@/views/stuZhiYuan/autoZhiYuan.vue'),
				meta: {
					anonymous: false,
					needLogin: true,
					needAuthority: true
				}
			},
			{
				path: '/register',
				name: 'register',
				component: () => import('@/views/person/register.vue'),
				meta: {
					anonymous: false,
				}
			},
			{
				path: '/test',
				name: 'test',
				component: () => import('@/views/test/index.vue'),
				meta: {
					anonymous: true,
					needLogin: false
				}
			},
			{
				path: '/firstbuy',
				name: 'firstbuy',
				component: () => import('@/views/product/product.vue'),
				meta: {
					title: '产品详情',
				}
			},
		]
	},
	{
		path: '/',
		name: 'shoplayout',
		component: () => import('@/views/product/ShopLayout.vue'),
		meta: {
			anonymous: true
		},
		children: [{
				path: '/receiveinfo',
				name: 'receiveinfo',
				component: () => import('@/views/product/receiveinfo.vue'),
				meta: {
					title: ''
				},
			},
			{
				path: '/receiveinfo2',
				name: 'receiveinfo2',
				component: () => import('@/views/product/receiveinfo2.vue'),
				meta: {
					title: ''
				},
			},
			{
				path: '/receiveinfo3',
				name: 'receiveinfo3',
				component: () => import('@/views/product/receiveinfo3.vue'),
				meta: {
					title: ''
				},
			},

			{
				path: '/gk',
				name: 'gk',
				component: () => import('@/views/product/gk.vue'),
				meta: {
					title: ''
				},
			},
			{
				path: '/gkyh',
				name: 'gkyh',
				component: () => import('@/views/product/gkyh.vue'),
				meta: {
					title: ''
				},
			},
			{
				path: '/yhreceiveinfo',
				name: 'yhreceiveinfo',
				component: () => import('@/views/product/yhreceiveinfo.vue'),
				meta: {
					title: ''
				},
			},
			{
				path: '/OrgEnabled',
				name: 'OrgEnabled',
				component: () => import('@/views/OrgEnabled.vue'),
				meta: {
					title: '机构已禁用'
				},
			},
		]
	},
	{
		path: '/404',
		name: '404',
		component: () => import('@/views/404.vue'),
		meta: {
			anonymous: true
		}
	},
	{
		path: '/401',
		name: '401',
		component: () => import('@/views/401.vue'),
		meta: {
			anonymous: true
		}
	},
	{
		path: '/pay',
		name: 'pay',
		component: () => import('@/views/pay/index.vue'),
		meta: {
			title: '',
			needLogin: false
		},
	},
	{
		path: '/orglink',
		name: 'orglink',
		component: () => import('@/views/orgLink/index.vue'),
		meta: {
			anonymous: false,
		}
	},
	{
		path: '/redriectpay',
		name: 'redriectpay',
		component: () => import('@/views/product/redriectpay.vue'),
		meta: {
			anonymous: true
		}
	},
	{
		path: '/openLogin',
		name: 'openLogin',
		component: () => import('@/views/account/openLogin.vue'),
		meta: {
			anonymous: true
		}
	},
	{
		path: '/orgpub',
		name: '/orgpub',
		component: () => import('@/views/org/orgpub.vue'),
		meta: {
			needLogin: false,
		}
	},
	{
		path: '/caiji',
		name: 'caiji',
		component: () => import('@/views/school/caiji.vue'),
		meta: {
			anonymous: true,
		}
	},
	{
		path: '/zfbPay',
		name: 'zfbPay',
		component: () => import('@/views/product/zfbPay.vue'),
		meta: {
			anonymous: true
		}
	},
	{
		path: '/a',
		name: 'LayoutSimple',
		redirect: '/ceping2',
		component: () => import('@/views/LayoutSimple.vue'),
		children: [{
				path: '/ceping2',
				name: 'ceping2',
				component: () => import('@/views/paper/index.vue'),
				meta: {
					anonymous: false,
					KeepAlive: true,
					title: '测评',
					showBack: false,
					needBaseInfo: false
				}
			},
			{
				path: '/cpdetail2',
				name: 'cpdetail2',
				component: () => import('@/views/paper/detail.vue'),
				meta: {
					anonymous: false,
					KeepAlive: true,
					title: '测评详情',
					needBaseInfo: false
				}
			}
		],
	}
]

const router = createRouter({
	history: createWebHashHistory(), //createWebHistory(process.env.BASE_URL),
	routes
})

function getQueryString(url, name) {
	return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url, name) || [, ""])[1]
		.replace(/\+/g, '%20')) || null
}

router.beforeEach((to, from, next) => {
	// debugger
	if (from.path == "/home" && to.path == "/logout") {
		store.commit("clearUserInfo");
		router.go(0);
		return;
	}

	if (to.path == "/logout") {
		store.commit("clearUserInfo");
		//强制刷新
		//router.go(0);
		return next({
			path: '/home'
		});
		return;
	}
	if (to.path == "/openLogin") {
		store.commit("clearUserInfo");
	}
	var user = store.getters.getUserInfo()
	// if (to.name != 'base' && user != null &&
	// 	(user.Mobile == '' || (user.CardType > 0 && user.CardType != globle.CARDTYPE_SCHCARD && user.Sbj ==
	// 		'' && user.WLType == ''))) {
	// 	store.commit('set_currentUrl', "/base");
	// 	return next({
	// 		path: '/base'
	// 	});
	// }

	if (to.name != 'base' && user != null && (user.Mobile == '' || user.Sex == '') &&
		to.meta.needBaseInfo != false) {
		//手机号填写后才能访问其它页面
		store.commit('set_currentUrl', "/base");
		return next({
			path: '/base'
		});
	}

	if (to.name == 'score' || to.name == 'score1' || to.name == 'score2' || to.name == 'fangan' ||
		to.name == 'record') {
		// if ((to.name == 'fangan' || to.name == 'record') && user != null && user.CardType == 1) {
		// 	router.push('/noserve')
		// 	return;
		// }
		//录取分查询、做方案等页面，必须完善选科或文理
		if (user != null && user.CardType > 0 && user.CardType != globle.CARDTYPE_SCHCARD &&
			((store.getters.getGKModel() == '老高考' && user.WLType == '') || (store.getters.getGKModel() !=
				'老高考' && user.Sbj == ''))) {
			store.commit('set_showCheckSbj', false);
			setTimeout(function() {
				store.commit('set_showCheckSbj', true);
			}, 100);
			// vue.$nextTick(() => {
			// 	store.commit('set_showCheckSbj', true);
			// });
			return;
		}
	}

	if (to.meta.needLogin) {
		if (store.getters.getToken().length <= 0) {
			let orgExtModel = store.getters.getOrgExtModel()
			if (orgExtModel != null) {
				let backUrl = orgExtModel.MbBackUrl
				if (!backUrl)
					backUrl = orgExtModel.PcBackUrl

				if (backUrl) {
					let tourl = encodeURIComponent(window.location.href)
					backUrl = backUrl.trim()
					if (backUrl.indexOf('?') > -1)
						backUrl += '&tourl=' + tourl
					else
						backUrl += '?tourl=' + tourl
					window.location.href = backUrl
					return
				} else if (to.path.toLowerCase() == '/stuzhiyuan/zhiyuan') { //此类写法不科学，临时待改
					window.location.href = '/'
					return
				}
			}

			if (store.state.loginToPath == to.path);
			store.commit("set_loginToPath", ''); //值相同时无法触发监听，打开弹窗
			store.commit("set_loginToPath", to.path);

			// var orgId = getQueryString(window.location.href, 'orgid');
			// router.push(from.path + "?needLogin=true&v=" + parseInt(new Date().getTime() / 1000) + (orgId ? (
			// 	'&orgid=' + orgId) : ""));

			// let routeData = router.resolve({
			// 	path: '/login'
			// });
			// window.open(routeData.href, '_blank');
			return;
		}

	}

	//对特殊模块检查授权
	if (to.meta.needAuthority) {
		api.CheckAuthority(to.path, rslt => {
			if (rslt.code == 1) {
				if (rslt.data.IsCan) {
					return next()
				} else {
					let remark = encodeURIComponent(rslt.data.Remark)
					let toUrl = encodeURIComponent(to.fullPath)
					// router.push('authorityInfo?toCard=' + rslt.data.ToCard + '&remark=' + remark +'&toUrl=' + toUrl);

					if (rslt.data.pageCode == 2) {
						router.push('orgServer')
					} else
						router.push('noserve?tocard=' + rslt.data.ToCard + '&toUrl=' + toUrl)
				}
			} else {
				alert(rslt.msg)
			}
		})
		return
	}

	store.commit('set_currentUrl', to.path);
	// if (getQueryString(to.fullPath, "clear")) {
	// 	store.commit("clearUserInfo");
	// 	return next({
	// 		path: '/login'
	// 	});
	// }

	//找不到页面
	if (to.matched.length == 0) {
		return next({
			path: '/404'
		});
	}
	//没有权限
	// if (to.path != '/index' && to.path != '/' && to.path != '/401' && to.path != '/404' && to.path
	// 	.toLowerCase() != '/login') {
	// 	if (store.getters.getMenuPermission(to.path)) {
	// 		return next({
	// 			path: '/401'
	// 		});
	// 	}
	// }
	// store.dispatch("onLoading", true);
	return next();
})

router.afterEach((to, from) => {
	// store.dispatch("onLoading", false);
})

export default router